export default __webpack_public_path__ + "82481b814e1829f4405d488b09e52768.png";